import { HttpRequestOptionsType } from './types';

export const DEFAULT_HTTP_REQUEST_OPTIONS = {
  // authMode removed to allow auto-detection based on context
} satisfies HttpRequestOptionsType;
